import { DAY_MS, HOUR_MS } from 'data/constants'
import {
    differenceInDays,
    differenceInHours,
    differenceInMinutes,
    format,
    isThisYear,
    isToday,
} from 'date-fns'

export function formatShortDate(date: number | Date) {
    if (isToday(date)) {
        return format(date, 'p')
    } else if (differenceInDays(new Date(), date) < 7) {
        return format(date, 'iii')
    } else if (isThisYear(date)) {
        return format(date, 'MM/dd')
    } else {
        return format(date, 'MM/dd/yy')
    }
}

export function formatDate(date: number | Date) {
    return format(date, 'PP')
}

export function formatUptime(date: Date) {
    const now = Date.now()
    const diff = now - date.getTime()
    switch (true) {
        case diff < HOUR_MS: {
            return differenceInMinutes(now, date) + 'm'
        }
        case diff < DAY_MS: {
            return differenceInHours(now, date) + 'h'
        }
        default: {
            return differenceInDays(now, date) + 'd'
        }
    }
}

/**
 * Formats a date for membership/renewal displays
 * @param date - Date or timestamp in milliseconds
 * @returns Formatted date string like "08/31/2025"
 */
export function formatMembershipDate(date: number | Date) {
    return format(date, 'MM/dd/yyyy')
}

/**
 * Formats a timestamp as a relative time string (e.g. "Today", "3 days ago", "2 weeks ago")
 * @param timestamp - Unix timestamp in seconds or milliseconds
 * @param isSeconds - Whether the timestamp is in seconds (default: false, assumes milliseconds)
 * @returns Relative time string
 */
export function formatRelativeTime(timestamp: number, isSeconds = false): string {
    if (!timestamp) {
        return ''
    }

    const date = new Date(isSeconds ? timestamp * 1000 : timestamp)
    const diffDays = differenceInDays(new Date(), date)

    if (diffDays === 0) {
        return 'Today'
    }
    if (diffDays === 1) {
        return 'Yesterday'
    }
    if (diffDays < 7) {
        return `${diffDays} days ago`
    }
    if (diffDays < 30) {
        return `${Math.floor(diffDays / 7)} weeks ago`
    }
    if (diffDays < 365) {
        return `${Math.floor(diffDays / 30)} months ago`
    }
    return `${Math.floor(diffDays / 365)} years ago`
}
